import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-topbar-header',
  templateUrl: './topbar-header.component.html',
  styleUrls: ['./topbar-header.component.scss']
})
export class TopbarHeaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
